import AutoReloadIcon from 'webpack-ant-icon-loader/src/runtime.js';
import('!!./dist.js').then(function (allIcons) {
  AutoReloadIcon.load(allIcons);
});
export default {
  name: 'add',
  theme: 'fill'
};